import { Button, Form, Input, Row, Typography } from 'antd';
import React from 'react';
import { NameOf } from 'src/utils';

export interface AccountFormProps {
  loading?: boolean;
  onFinish?: (values: AccountFormFormData) => void;
}

// Terrible name, oh well
export interface AccountFormFormData {
  account: string;
}

const AccountForm: React.FC<AccountFormProps> = (props) => {
  const [form] = Form.useForm();

  return (
    <div className='location-settings-details standard-form-layout'>
      <Form
        layout='inline'
        requiredMark={false}
        form={form}
        onFinish={props.onFinish}
      >
        {/* Account # */}
        <Form.Item
          label={<Typography.Text strong>Account #</Typography.Text>}
          colon={false}
          name={NameOf<AccountFormFormData>('account')}
          rules={[
            { required: true, message: 'Account is required', min: 1 }
          ]}
        >
          <Input allowClear disabled={props.loading} />
        </Form.Item>

        <Form.Item>
          <Button type='primary' htmlType="submit" loading={props.loading}>Go</Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default AccountForm;
